import React, {useState, useEffect} from 'react'
import AccountApi from '../api/AccountApi';

const AccountForm = ({accountId, onSubmits, toogle}) => {
    const nonce = devsAccountingApi.nonce;
    const [message, setMessage] = useState("");
    const [fetchData, setFetchingData] = useState(false);
    const [errors, setErrors] = useState({});
    const [state, setState] = useState({
        name: "",
        bank_name: "",
        opening_balance: 0,
        nonce: nonce
    });
    const [loading, setLoading] = useState(false); // Loading state added

    useEffect(() => {
        if(accountId){
            getContact(accountId);
        }
    }, [accountId]);

    const handleChange = (e) => {
        const { name, value } = e.target;
            setState({
                ...state,
                [name]: value,
            });
    };

    const getContact = async (accountId) => {
        setFetchingData(true);
        const res = await AccountApi.show(accountId);
        if(res){
            setFetchingData(false);
            setState(res);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const res = await AccountApi.save(state);
        setErrors('')
        if (res.errors) {
            setErrors(res.errors);
            setLoading(false);
        } else {
            setMessage(res.message);
            setLoading(false);
            onSubmits();
            toogle();
        }
    };

  return (
    <div>
        {message &&
            <div className="bg-blue-100 border-t border-b border-blue-500 text-blue-700 px-4 py-3" role="alert">
                <p className="font-bold">{message}</p>
            </div>
        }
        {!fetchData ?
            <section className="p-6 mx-auto rounded-md ">
                <form onSubmit={handleSubmit}>
                    <div className='grid grid-cols-2'>
                        <div>
                            <h2 className="text-lg font-semibold text-gray-700 capitalize dark:text-white">{accountId ? 'Edit' : 'Add'} Accounts</h2>
                        </div>
                        <div className="flex justify-end">
                            <button type='submit' className="px-6 py-2 leading-5 text-white transition-colors duration-200 transform bg-gray-700 rounded-md hover:bg-gray-600 focus:outline-none focus:bg-gray-600">
                                {loading ? 'Submitting...' : 'Submit'} {/* Display 'Submitting...' when loading, 'Submit' otherwise */}
                            </button>
                        </div>
                    </div>
                    <div className="grid grid-cols-2 gap-6 mt-4">
                        <div>
                            <label className="text-gray-700 dark:text-gray-200" htmlFor="name">Name</label>
                            <input id="name" type="text" className="block w-full px-4 py-2 mt-2 text-gray-700 bg-white border border-gray-300 rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-500 focus:outline-none focus:ring" name="name"
                                value={state.name} onChange={handleChange} />
                            {errors.name && <p className="text-red-500 text-xs mt-1">{errors.name}</p>}
                        </div>

                        <div>
                            <label className="text-gray-700 dark:text-gray-200" htmlFor="bank_name">Bank Name</label>
                            <input id="bank_name" type="text" className="block w-full px-4 py-2 mt-2 text-gray-700 bg-white border border-gray-300 rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-500 focus:outline-none focus:ring" name="bank_name"
                                value={state.bank_name} onChange={handleChange} />
                            {errors.bank_name && <p className="text-red-500 text-xs mt-1">{errors.bank_name}</p>}
                        </div>
                        <div>
                            <label className="text-gray-700 dark:text-gray-200" htmlFor="opening_balance">Opening Balance</label>
                            <input id="opening_balance" type="number" className="block w-full px-4 py-2 mt-2 text-gray-700 bg-white border border-gray-300 rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-500 focus:outline-none focus:ring" name="opening_balance"
                                value={state.opening_balance} onChange={handleChange} />
                            {errors.opening_balance && <p className="text-red-500 text-xs mt-1">{errors.opening_balance}</p>}
                        </div>
                    </div>
                </form>
            </section>
            : <div className='m-auto'><p className='text-2xl text-bold text-center'>Loading...</p> </div>}
    </div>
  )
}

export default AccountForm;
